import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  refreshTasks,
  setTasksLoadStatus,
  addTasks as addTasksToUserGroup
} from 'store/redux/userGroups'

export default function * fetchUserGroupTasks (action) {
  const { id, refresh } = action.payload

  const batchedActions = []

  if (refresh) {
    batchedActions.push(refreshTasks({
      id
    }))
  }

  batchedActions.push(setTasksLoadStatus({
    id,
    loading: true,
    loaded: false
  }))

  yield put(batchedActions)

  try {
    const { Tasks } = yield call(apiGetData, 'GroupSyncSourceTasks', {
      groupId: id
    })

    const batchedActions = [
      setTasksLoadStatus({
        id,
        loading: false,
        loaded: true
      })
    ]

    if (Tasks.length) {
      batchedActions.push(addTasksToUserGroup({
        id,
        tasks: Tasks.map(Task => ({
          id: Task.Id,
          status: Task.Status,
          endTimestamp: Task.EndTimestamp
        }))
      }))
    }

    yield put(batchedActions)
  } catch (error) {
    yield put(setTasksLoadStatus({
      id,
      loading: false,
      loaded: false
    }))

    throw error
  }
}
